export default __webpack_public_path__ + "static/media/arrow-right.5872a21b.svg";